import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NavTabBar } from '@asad/crane-ui'

/** Zakładki modułów Administracji. Dostępu strzeże `ProtectedRoute` w `app-router.tsx`. */

export type AdminTab = {
  to: string
  labelKey: string
  match: (pathname: string) => boolean
}

export const ADMIN_TABS: AdminTab[] = [
  { to: '/admin/users', labelKey: 'admin.tabs.users', match: (p) => p.startsWith('/admin/users') },
  { to: '/admin/firms', labelKey: 'admin.tabs.firms', match: (p) => p.startsWith('/admin/firms') },
  { to: '/admin/devices', labelKey: 'admin.tabs.devices', match: (p) => p.startsWith('/admin/devices') },
  {
    to: '/admin/inverters-and-alarms',
    labelKey: 'admin.tabs.invertersAndAlarms',
    match: (p) => p.startsWith('/admin/inverters-and-alarms'),
  },
  {
    to: '/admin/notifications',
    labelKey: 'admin.tabs.notifications',
    match: (p) => p.startsWith('/admin/notifications'),
  },
  { to: '/admin/wizard', labelKey: 'admin.tabs.wizard', match: (p) => p.startsWith('/admin/wizard') },
]

export const FIRST_ADMIN_TAB = ADMIN_TABS[0].to

const AdminLayout = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const barRef = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    const active = barRef.current?.querySelector<HTMLElement>('[data-active="true"]')

    active?.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' })
  }, [pathname])

  return (
    <div className='crane-ui-surface flex flex-col gap-3.5 text-crane-foreground'>
      <div ref={barRef}>
        <NavTabBar
          items={ADMIN_TABS.map((tab) => ({ to: tab.to, label: t(tab.labelKey), match: tab.match }))}
          pathname={pathname}
        />
      </div>

      <div className='flex flex-col gap-3.5'>
        <Outlet />
      </div>
    </div>
  )
}

export { AdminLayout }
export default AdminLayout
